export default __webpack_public_path__ + "static/blob1-1f56019f2509831c733e5b04fdbeee0a.svg";